/* Cart free gifts text change */
document.addEventListener('DOMContentLoaded', function() {
  function updateSamplesText() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartValue = cart.total_price / 100;
        const heading = document.querySelector('.cart-template .featured-collection .rich-text__heading .block');
        if (!heading) return;
        if (cartValue < 30) {
          heading.textContent = 'Įsigykite produktų virš 30 Eur ir pasirinkite norimą mėginuką - DOVANŲ!';
        } else if (cartValue >= 30 && cartValue < 80) {
          heading.textContent = 'Jums priklauso 1 nemokamas mėginukas';
        } else if (cartValue >= 80) {
          heading.textContent = 'Jums priklauso 2 nemokami mėginukai';
        }
      });
  }

  updateSamplesText();
  document.addEventListener('cart:updated', updateSamplesText);
});